// Module
var code = "<!-- ko if: areRequestDetailsLoaded --> <!-- ko component: { name: requestComponentName, params: params } --><!-- /ko --> <!-- /ko -->";
// Exports
export default code;